import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * items: array of {label, to?} where the last one is the current page (no `to`).
 * If none provided, uses the given `trail` prop as-is.
 */
export default function Breadcrumbs({ items = [] }) {
  const trail = [{ label: "Home", to: "/app", icon: Home }, ...items];
  return (
    <nav aria-label="Breadcrumb" className="text-xs text-zinc-500 mb-5" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1">
        {trail.map((item, idx) => {
          const isLast = idx === trail.length - 1;
          const Icon = item.icon;
          return (
            <li key={`${item.label}-${idx}`} className="inline-flex items-center gap-1">
              {idx > 0 && <ChevronRight className="w-3 h-3 text-zinc-400 mx-0.5" />}
              {isLast || !item.to ? (
                <span
                  aria-current="page"
                  className="text-zinc-800 font-medium inline-flex items-center gap-1"
                >
                  {Icon && <Icon className="w-3 h-3" />}
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  className="hover:text-[#1D4ED8] hover:underline inline-flex items-center gap-1"
                >
                  {Icon && <Icon className="w-3 h-3" />}
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
